var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-message"},[_vm._v("\n    Want to see more data?\n  ")]),_vm._v(" "),_c('PrimaryButton',{on:{"click":_vm.createReport}},[_vm._v("\n    Create Report\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }